/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.5.24",
    versionName: "0.3.0-nightly.2026.5.24",
    versionChannel: "nightly",
    buildDate: "2026-05-24T00:34:54.722Z",
    commitHash: "33e2b5dfd622bc669d0032780d6220513d529455",
};
